import React, { Component } from 'react';
import CheckDefecto from "../../../Common/Components/CheckDefecto"

class Limites extends Component {
    constructor(props){
        super(props)
        this.state={
            limiteDeCompraIngresado:"",
            limiteDeCompraEnCuotasDesde:this.props.solicitudCuenta.productoVisaSeleccionado.FLCCDesde,
            limiteDeCompraEnCuotasHasta:this.props.solicitudCuenta.productoVisaSeleccionado.FLCCHasta,
            limiteDeCompraEnCuotasIngresado:"",            
            limiteDeAdelantosIngresado:"",
            

        }
        this.onLimitesInputChange = this.onLimitesInputChange.bind(this);
    }
    onLimitesInputChange(event) {
        const { value, dataset } = event.target;
        
            if ( /^\d{0,2}(\.\d{1,2})?$/.test(value) || (!isNaN(value.substring(0,value.length-2)) && value[value.length-1] == ".")|| value == "100" || value == "") {
                //SI ES UN NUMERO CON DOS ENTEROS Y DOS DECIMALES, O UN NUMERO CON UN PUNTO AL FINAL (PARA QUE TE PERMITA SEGUIR ESCRIBIENDO EL DECIMAL) O 100, PERMITE EL INGRESO DEL VALOR EN EL INPUT.
                let newState = {
                    [dataset.code]: value
                }
                if (dataset.code == "LimiteDeCompraClienteAdicionalSeleccionado") {
                    newState = {
                        ...newState,
                        limiteDeCompraIngresado: value
                    }
                }
                if (dataset.code == "LimiteDeCompraEnCuotasClienteAdicionalSeleccionado") {
                    newState = {
                        ...newState,
                        limiteDeCompraEnCuotasIngresado: value
                    }
                }
                if (dataset.code == "LimiteDeAdelantosClienteAdicionalSeleccionado") {
                    newState = {
                        ...newState,
                        limiteDeAdelantosIngresado: value
                    }
                }
                if (dataset.code == "LimitePorTransaccionAdicionalSeleccionado") {
                    newState = {
                        ...newState,
                        limiteDeTransaccionIngresado: value
                    }
                }
                this.setState(newState);
                this.props.changeInput(dataset.code, value)
            }  
    }
        
    componentWillReceiveProps(nextProps){
        this.setState({
            porcBonificacion:nextProps.data.porcentajeCostoEmision,
            cantidadDeCuotas: nextProps.data.cuotasCostoEmisionSeleccionadas,
        })
    }
    render() {
        const{data, tarjetas, selectCheckBox}=this.props
        const{datosProductoSeleccionado, GET_MODALIDAD_DISTRIBUCION_LIMITE_PRODUCTO_ID, modeloDistribucionId}=tarjetas.solicitudCuenta
        
        let restringeLimites = this.props.administradora == "V" ? GET_MODALIDAD_DISTRIBUCION_LIMITE_PRODUCTO_ID.filter(d=>d.Id==modeloDistribucionId)[0].CODIGO : false
        
        let errorLimitesUnicos = false;
        let errorLimiteCompra = false;
        let errorLCC = false;
        let errorLimiteAdelantos = false;
        let tieneLimiteTransaccion = true;
        
        if((restringeLimites == "LIMUNICO" || restringeLimites == "LIMUNICO_I" || tarjetas.tipoEmpresa.EmpresaIndividuos == "E") && !data.SeleccionModeloDistribucionLimitesClienteAdicional) selectCheckBox("SeleccionModeloDistribucionLimitesClienteAdicional", true)
        
        if(data.SeleccionModeloDistribucionLimitesClienteAdicional){
            //SI SE SELECCIONÓ "LÍMITES REDUCIDOS" SE DEBE VALIDAR QUE LOS 3 CAMPOS ESTÉN COMPLETOS Y QUE DE HABER LÍMITE ÚNICO POR TARJETA NO SE SOBREPASE EL %100
            if(restringeLimites == "LIMUNICO" || restringeLimites == "LIMUNICO_I" || tarjetas.tipoEmpresa.EmpresaIndividuos == "E") {
                let limitesCompraAdicionales=0;
                if(data.cuentasAdicionales.length > 0){//si hay clientes adicionales sumo los porcentajes asignados  
                    data.cuentasAdicionales.map(a=>{limitesCompraAdicionales += parseFloat(a.LimiteDeCompra);})
                }
                if((parseFloat(limitesCompraAdicionales) + parseFloat(data.LimiteDeCompraClienteAdicionalSeleccionado) >100)){
                    errorLimitesUnicos = true
                }
            }  
            errorLimiteAdelantos = parseFloat(data.LimiteDeAdelantosClienteAdicionalSeleccionado )<=0 || data.LimiteDeAdelantosClienteAdicionalSeleccionado == "";
            errorLCC = parseFloat(data.LimiteDeCompraEnCuotasClienteAdicionalSeleccionado )<=0 || data.LimiteDeCompraEnCuotasClienteAdicionalSeleccionado == "";
            errorLimiteCompra = parseFloat(data.LimiteDeCompraClienteAdicionalSeleccionado )<=0 || data.LimiteDeCompraClienteAdicionalSeleccionado == "";
        } 
    
        if(tarjetas.esCuentaExistente){
            //SI ES CUENTA EXISTENTE SE MOSTRARÁ EL CHECK DE LÍMITE POR TRANSACCIÓN SÓLO SI LA EMPRESA LO PERMITE
            if(Array.isArray(tarjetas.empresas)){
                tarjetas.empresas.map(empresa=>{
                    if(empresa.Id == tarjetas.empresaVisaSeleccionada.Id) tieneLimiteTransaccion = empresa.TieneLimiteTransaccion;
                })
            }
        }

      return (
            <div className="row top-separator-xs">
                 <div className="col-xs-12">
                    <label className="label-primary">{"Límites"}</label>
                {restringeLimites!=="SINLIMITE"&&
                    <CheckDefecto
                        nombre={"Límites Reducidos"}
                        check={( restringeLimites == "LIMUNICO"  || restringeLimites == "LIMUNICO_I" || tarjetas.tipoEmpresa.EmpresaIndividuos == "E" ) ? true : data.SeleccionModeloDistribucionLimitesClienteAdicional}
                        referencia={"SeleccionModeloDistribucionLimitesClienteAdicional"}
                        selectCheckBox={( restringeLimites == "LIMUNICO" || restringeLimites == "LIMUNICO_I" || tarjetas.tipoEmpresa.EmpresaIndividuos == "E" ) ? ()=>null : (event) => selectCheckBox("SeleccionModeloDistribucionLimitesClienteAdicional", event.target.checked)}
                    />}
                    {data.SeleccionModeloDistribucionLimitesClienteAdicional && <div>
                    <div className="row">
                        <div className="col-xs-2">
                            <label className="label-secondary">Límite de Compra</label>
                        </div>
                        <div className="col-xs-1">
                            <input 
                            className="form-control input-Short"
                            type="text"
                            value={data.LimiteDeCompraClienteAdicionalSeleccionado}
                            onChange={e=>this.onLimitesInputChange(e)}
                            data-code="LimiteDeCompraClienteAdicionalSeleccionado"
                            />
                            
                        </div>
                        <div className="col-xs-2">
                            <label className="label-secondary">
                                {"% (entre 0.01% y 100%)"}
                            </label>
                        </div>
                        <div className="col-md-12">
                            {(data.ERROR_ADICIONAL["seleccionoLimites"] == false) && errorLimiteCompra
                            && <label className="error">{"Debe agregar Límite de Compra."}</label>
                            }
                        </div>
                        <div className="col-md-12">
                            {(data.ERROR_ADICIONAL["seleccionoLimites"] == false) && errorLimitesUnicos
                            && <label className="error">{"La cuenta opera con modalidad de control de límite por Tarjeta y los integrantes actuales alcanzan el 100% del límite de compra, por lo que deberá disminuir los porcentajes asignados a los integrantes actuales para poder solicitar el alta de nuevos integrantes, o bien, modificar la Cuenta para que no opere con este control."}</label>
                            }
                        </div>
                    </div>
                    <div className="row top-separator-xs"></div>
                    <div className="row">
                        <div className="col-xs-2">
                            <label className="label-secondary">Límite de Compra en Cuotas</label>
                        </div>
                        <div className="col-xs-1">
                            <input 
                            className="form-control input-Short"
                            type="text"
                            value={data.LimiteDeCompraEnCuotasClienteAdicionalSeleccionado}
                            
                            onChange={e=>this.onLimitesInputChange(e)}
                            data-code="LimiteDeCompraEnCuotasClienteAdicionalSeleccionado"
                            />
                        </div>
                        <div className="col-xs-2">
                            <label className="label-secondary">
                            {"% (entre 0.01% y 100%)"}
                            </label>
                        </div>
                        <div className="col-md-12">
                            {(data.ERROR_ADICIONAL["seleccionoLimites"] == false) && errorLCC
                            && <label className="error">{"Debe agregar Límite de Compra en Cuotas."}</label>
                            }
                        </div>
                    </div>
                    <div className="row top-separator-xs"></div>
                    <div className="row">
                        <div className="col-xs-2">
                            <label className="label-secondary">Límite en Adelantos</label>
                        </div>
                        <div className="col-xs-1">
                            <input 
                                className="form-control input-Short" 
                                type="text"
                                value={data.LimiteDeAdelantosClienteAdicionalSeleccionado}   
                                
                                onChange={e=>this.onLimitesInputChange(e)}
                                data-code="LimiteDeAdelantosClienteAdicionalSeleccionado"
                                 />
                        </div>
                        <div className="col-xs-2">
                            <label className="label-secondary">
                            {"% (entre 0.01% y 100%)"}
                            </label>
                        </div>
                        <div className="col-md-12">
                            {(data.ERROR_ADICIONAL["seleccionoLimites"] == false) && errorLimiteAdelantos
                            && <label className="error">{"Debe agregar Límite en Adelantos."}</label>
                            }
                        </div>
                    </div>
                    </div>}
                    <div className="row top-separator-xs"></div>
                   {(tarjetas.tipoEmpresa.EmpresaIndividuos=="E" && tieneLimiteTransaccion ) && <CheckDefecto
                        nombre={"Establecer Límite de Transacción"}
                        check={data.SeleccionLimiteTransaccionClienteAdicional}
                        referencia={"SeleccionLimiteTransaccionClienteAdicional"}
                        selectCheckBox={(event) => selectCheckBox("SeleccionLimiteTransaccionClienteAdicional", event.target.checked)}
                    />}

                   {data.SeleccionLimiteTransaccionClienteAdicional&& <div className="row">
                        <div className="col-xs-2">
                            <label className="label-secondary">Límite por Transacción</label>
                        </div>
                        <div className="col-xs-1">
                            <input 
                            className="form-control input-Short" 
                            type="text"
                            value={data.LimitePorTransaccionAdicionalSeleccionado} 
                            onChange={e=>this.onLimitesInputChange(e)}
                            data-code="LimitePorTransaccionAdicionalSeleccionado"
                            />
                        </div>
                        <div className="col-xs-2">
                            <label className="label-secondary">%</label>
                        </div>
                    </div>}
                    {(data.ERROR_ADICIONAL["seleccionoLimiteTransaccion"] == false)
                        && <label className="error">{"Debe agregar límite por transacción"}</label>
                    }
                </div>
            </div>
     )
    }
};

export default Limites;